import generateTimeSeed from '@glass/shared/modules/random/generateTimeSeed';
import randomFromSeed from '@glass/shared/modules/random/randomFromSeed';

const generateRangeTimeSeed = (min, max, seed) =>
  generateTimeSeed(min + Math.floor(randomFromSeed(seed) * (max - min)));

export default generateRangeTimeSeed;
